import { useState, useEffect } from 'react';
import { Phone, Mail, MapPin, Send, Clock } from 'lucide-react';

const Contact = () => {
  useEffect(() => {
    document.title = 'Kontak Kami - CV Samudera Alam Perkasa';
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real implementation, you would handle form submission here
    console.log('Form submitted:', formData);
    alert('Pesan Anda telah dikirim. Kami akan segera menghubungi Anda.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    });
  };

  return (
    <>
      {/* Page Header */}
      <div className="bg-navy-900 text-white py-20 mt-16">
        <div className="container-custom">
          <h1 className="text-4xl font-bold mb-4">Hubungi Kami</h1>
          <p className="text-lg text-gray-300 max-w-3xl">
            Punya pertanyaan atau ingin bekerja sama? Hubungi kami dan kami akan segera menghubungi Anda kembali.
          </p>
        </div>
      </div>

      {/* Contact Information & Form */}
      <section className="py-16">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div>
              <h2 className="section-title mb-8">Informasi Kontak</h2>
              
              <div className="space-y-8 mb-12">
                <div className="flex items-start">
                  <div className="bg-primary-600 p-3 rounded-full text-white mr-4">
                    <MapPin size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-navy-900 mb-1">Alamat Kantor</h3>
                    <p className="text-gray-600">
                      Jl. Juwingan No 94, Gubeng Kertajaya, <br />
                      Surabaya, Jawa Timur, Indonesia
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-primary-600 p-3 rounded-full text-white mr-4">
                    <Phone size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-navy-900 mb-1">Telepon</h3>
                    <p className="text-gray-600">+62 877-1208-1994</p>
                    <p className="text-gray-600">+62 31-XXX-XXXX (Kantor)</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-primary-600 p-3 rounded-full text-white mr-4">
                    <Mail size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-navy-900 mb-1">Email</h3>
                    <p className="text-gray-600">info@samuderaalam.com</p>
                    <p className="text-gray-600">career@samuderaalam.com (Karir)</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-primary-600 p-3 rounded-full text-white mr-4">
                    <Clock size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-navy-900 mb-1">Jam Operasional</h3>
                    <p className="text-gray-600">Senin - Jumat: 08:00 - 17:00</p>
                    <p className="text-gray-600">Sabtu: 09:00 - 14:00</p>
                    <p className="text-gray-600">Minggu & Libur: Tutup</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="font-semibold text-navy-900 mb-4">Kantor Cabang</h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-navy-900 mb-1">Jakarta</h4>
                    <p className="text-gray-600">Jl. Sudirman No. XX, Jakarta Selatan</p>
                    <p className="text-gray-600">Telp: +62 21-XXX-XXXX</p>
                  </div>
                  <div>
                    <h4 className="font-medium text-navy-900 mb-1">Bandung</h4>
                    <p className="text-gray-600">Jl. Pasirkaliki No. XX, Bandung</p>
                    <p className="text-gray-600">Telp: +62 22-XXX-XXXX</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="section-title mb-8">Kirim Pesan</h2>
              
              <div className="bg-white rounded-lg shadow-md p-8">
                <form onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                        Nama Lengkap <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                        required
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                        Email <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                        Nomor Telepon
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
                        Subjek <span className="text-red-500">*</span>
                      </label>
                      <select
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                        required
                      >
                        <option value="" disabled>Pilih Subjek</option>
                        <option value="Informasi Layanan">Informasi Layanan</option>
                        <option value="Kerjasama Bisnis">Kerjasama Bisnis</option>
                        <option value="Rekrutmen">Rekrutmen</option>
                        <option value="Lainnya">Lainnya</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="mb-6">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                      Pesan <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={5}
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                      required
                    ></textarea>
                  </div>
                  
                  <button
                    type="submit"
                    className="btn btn-primary w-full flex items-center justify-center"
                  >
                    <Send size={18} className="mr-2" />
                    Kirim Pesan
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
              Lokasi Kami
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
              Kunjungi kantor kami untuk konsultasi langsung dengan tim kami.
            </p>
          </div>
          
          <div className="bg-white rounded-lg overflow-hidden shadow-md">
            <div className="h-[450px] w-full">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3957.598295656992!2d112.74559511472945!3d-7.2792094947752!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd7fbad1203c95d%3A0x2a8c78a45559be56!2sJl.%20Juwingan%2C%20Surabaya%2C%20Jawa%20Timur!5e0!3m2!1sid!2sid!4v1651234567890!5m2!1sid!2sid" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Peta Lokasi CV Samudera Alam Perkasa"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
              Pertanyaan Umum
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
              Temukan jawaban untuk pertanyaan yang sering diajukan tentang layanan kami.
            </p>
          </div>
          
          <div className="max-w-3xl mx-auto">
            <div className="space-y-6">
              {[
                {
                  question: 'Bagaimana proses rekrutmen tenaga kerja dilakukan?',
                  answer: 'Proses rekrutmen dimulai dengan analisis kebutuhan klien, dilanjutkan dengan seleksi kandidat melalui berbagai tahapan, termasuk wawancara dan tes keterampilan, serta verifikasi latar belakang sebelum penempatan.',
                },
                {
                  question: 'Berapa lama waktu yang dibutuhkan untuk mendapatkan tenaga kerja?',
                  answer: 'Waktu yang dibutuhkan bervariasi tergantung pada jenis posisi dan kebutuhan spesifik. Untuk posisi umum, kami biasanya dapat menyediakan kandidat dalam 2-3 minggu, sedangkan untuk posisi spesialis mungkin membutuhkan waktu 3-4 minggu.',
                },
                {
                  question: 'Apakah CV Samudera Alam Perkasa menyediakan layanan untuk industri apa saja?',
                  answer: 'Kami melayani berbagai sektor industri termasuk konstruksi, manufaktur, teknologi informasi, perhotelan, kesehatan, pendidikan, ritel, logistik, perbankan, dan lainnya.',
                },
                {
                  question: 'Bagaimana dengan jaminan kualitas tenaga kerja yang disediakan?',
                  answer: 'Kami memberikan jaminan kualitas melalui proses seleksi ketat, verifikasi latar belakang, dan program pelatihan. Jika ada masalah dengan tenaga kerja yang disediakan, kami siap memberikan penggantian dalam periode tertentu sesuai kesepakatan.',
                },
                {
                  question: 'Apakah ada biaya konsultasi awal?',
                  answer: 'Tidak, konsultasi awal untuk membahas kebutuhan tenaga kerja perusahaan Anda diberikan secara gratis tanpa kewajiban.',
                },
              ].map((faq, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
                  <details className="group">
                    <summary className="flex items-center justify-between p-6 cursor-pointer">
                      <h3 className="text-lg font-semibold text-navy-900">{faq.question}</h3>
                      <span className="ml-6 flex-shrink-0 text-gray-500 group-open:rotate-180 transition-transform duration-300">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </summary>
                    <div className="px-6 pb-6 text-gray-600">
                      <p>{faq.answer}</p>
                    </div>
                  </details>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;